import { useEffect } from "react";
import { Layout } from "components";
import ReactGA from "react-ga4";
import { Divider, Typography } from "theme";
import { ArrowLeft, Chat, Location, Phone } from "theme/icons";

import { Box, Grid2, List, ListItem } from "@mui/material";
import { styled } from "@mui/material/styles";

import Carousel from "../components/Carousel/Carousel.tsx";
import LocationMap from "../components/LocationMap/LocationMap.tsx";

const StyledList = styled(List)(() => {
  return {
    margin: 0,
    padding: 0,
    listStyleType: "none",
  };
});

const StyledListItem = styled(ListItem)(({ theme }) => {
  return {
    margin: theme.spacing(0.5, 0),
    padding: 0,
    paddingLeft: theme.spacing(1.5),
    position: "relative",

    "&:before": {
      content: '"-"',
      position: "absolute",
      top: 0,
      color: theme.palette.text.primary,
      marginLeft: theme.spacing(-1.5),
    },
  };
});

const StyledLink = styled("a")(({ theme }) => {
  return {
    display: "flex",
    columnGap: theme.spacing(0.5),
    textDecoration: "none",
    alignItems: "center",
    color: theme.palette.text.primary,
  };
});

const AboutCompany = () => {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.href, title: "ABOUT_PAGE" });
  }, []);

  return (
    <Layout>
      <Grid2 container flexDirection="column" rowGap={2.5}>
        <Divider />
        <Box>
          <Typography
            mb={1.5}
            variant="h2"
            color="primary"
            textTransform="uppercase"
            weight="regular"
          >
            Про нас
          </Typography>
          <Typography variant="body1" color="primary" weight="light">
            Переваги кімнати:
          </Typography>
          <StyledList>
            <StyledListItem>
              <Typography variant="body1" color="primary" weight="light" textAlign="justify">
                Захоплюючий вигляд на Високий Замок з панорамних вікон.
              </Typography>
            </StyledListItem>
            <StyledListItem>
              <Typography variant="body1" color="primary" weight="light" textAlign="justify">
                Локація обладнана рейковою системою для кріплення світла при стелі (налаштування
                можливе лише адміністратором).
              </Typography>
            </StyledListItem>
          </StyledList>
        </Box>
        <Divider />
        <Box>
          <Typography
            mb={1.5}
            variant="h2"
            color="primary"
            textTransform="uppercase"
            weight="regular"
          >
            Контактна інформація
          </Typography>
          <Grid2 container flexDirection="column" rowGap={2.5}>
            <Box>
              <Typography
                mb={1}
                variant="body2"
                color="primary"
                textTransform="uppercase"
                weight="regular"
              >
                Адреса:
              </Typography>
              <StyledLink href="https://maps.app.goo.gl/WWyfAHrZYBEQS4gf6" target="_blank">
                <Location />
                <Typography
                  variant="body2"
                  color="primary"
                  textTransform="uppercase"
                  weight="regular"
                  style={{
                    opacity: 0.8,
                  }}
                >
                  вул. Жовківська 14, м. Львів, Україна
                </Typography>
              </StyledLink>
            </Box>
            <Box>
              <Typography
                mb={1}
                variant="body2"
                color="primary"
                textTransform="uppercase"
                weight="regular"
              >
                телефон:
              </Typography>
              <StyledLink href="tel:+380638561105">
                <Phone />
                <Typography
                  variant="body2"
                  color="primary"
                  weight="regular"
                  style={{
                    opacity: 0.8,
                  }}
                >
                  +38(063)856-11-05
                </Typography>
              </StyledLink>
            </Box>
            <Box>
              <Typography
                mb={1}
                variant="body2"
                color="primary"
                textTransform="uppercase"
                weight="regular"
              >
                Email:
              </Typography>
              <StyledLink href="mailto:panorama.studio.lviv@gmail.com">
                <Chat />
                <Typography
                  variant="body2"
                  color="primary"
                  weight="regular"
                  style={{
                    opacity: 0.8,
                  }}
                >
                  panorama.studio.lviv@gmail.com
                </Typography>
              </StyledLink>
            </Box>
          </Grid2>
        </Box>
        <Divider />
        <Box>
          <Typography
            mb={1.5}
            variant="h2"
            color="primary"
            textTransform="uppercase"
            weight="regular"
          >
            Соціальні медіа
          </Typography>
          <Typography
            style={{
              opacity: 0.8,
            }}
            variant="body1"
            color="primary"
            weight="light"
            fontStyle="italic"
          >
            Слідкуйте за нашими оновленнями та працюйте в соціальних мережах!
          </Typography>

          <Grid2 mt={2.5} container flexDirection="column" rowGap={2.5}>
            <StyledLink href="https://google.com" target="_blank">
              <Typography
                variant="body1"
                color="primary"
                textTransform="uppercase"
                style={{
                  textDecoration: "underline",
                }}
              >
                insta
              </Typography>
              <ArrowLeft />
            </StyledLink>
            <StyledLink href="https://google.com" target="_blank">
              <Typography
                variant="body1"
                color="primary"
                textTransform="uppercase"
                style={{
                  textDecoration: "underline",
                }}
              >
                Tiktok
              </Typography>
              <ArrowLeft />
            </StyledLink>
          </Grid2>
        </Box>
        <Divider />
      </Grid2>
      <Box>
        <Carousel />
      </Box>
      <Grid2 container flexDirection="column" rowGap={2.5}>
        <Divider />
        <Box>
          <Typography
            mb={1.5}
            variant="h2"
            color="primary"
            textTransform="uppercase"
            weight="regular"
          >
            Місцезнаходження
          </Typography>
          <StyledLink href="https://maps.app.goo.gl/WWyfAHrZYBEQS4gf6" target="_blank">
            <Location />
            <Typography
              variant="body2"
              color="primary"
              textTransform="uppercase"
              weight="regular"
              style={{
                opacity: 0.8,
              }}
            >
              вул. Жовківська 14, м. Львів, Україна
            </Typography>
          </StyledLink>
          <LocationMap />
        </Box>
      </Grid2>
    </Layout>
  );
};

export default AboutCompany;
